import { createSelector } from "reselect";

const getPainel = (state) => state.painel;

export const getDados = createSelector(getPainel, (state) => state.painel);
export const getApolices = createSelector(getPainel, (state) => state.apolices);
export const getRateios = createSelector(getPainel, (state) => state.rateios);
export const getGraficoSinistralidade = createSelector(getPainel, (state) => state.graficoSinistralidade);
